import React from 'react';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { ComboBox, ComboBoxProps } from '@progress/kendo-react-dropdowns';

type DynamicComboBoxProps = ComboBoxProps & {
  /**
   * Optional width for the input
   */
  width?: number | string;

  /**
   * Optional min width for the popup
   */
  minWidth?: number | string;
};

const DynamicComboBox: React.FC<DynamicComboBoxProps> = ({
  width = 220,
  minWidth,
  popupSettings,
  style,
  ...props
}) => {
  const popupMinWidth = minWidth ?? width;

  return (
    <ComboBox
      {...props}
      style={{ ...style, width }} // set input width
      popupSettings={{
        width: 'auto', // expand to fit content
        style: { minWidth: popupMinWidth }, // enforce min width
        ...popupSettings,
      }}
    />
  );
};

export default DynamicComboBox;
